import { useEffect, useRef, useContext } from 'react';
import { io, Socket } from 'socket.io-client';
import AuthContext from '../contexts/AuthContext';
import NotificationContext, {
  INotification,
} from '../contexts/NotificationContext';
import PendingRequestsContext, {
  RequestDetails,
} from '../contexts/PendingRequestsProvider';
import { RECEIVE_REQUEST } from '../constants/localstorage';

const useNotificationSocket = () => {
  const socket = useRef<Socket | null>(null);
  const {
    handleNewNotification,
    setHasNewNotification,
    addToReceiveRequestQueue,
    isAppLoaded,
  } = useContext(NotificationContext);
  const { setToggleModal, setRequestDetails } = useContext(
    PendingRequestsContext,
  );
  const { userData: user } = useContext(AuthContext);

  useEffect(() => {
    if (user) {
      const url = process.env.REACT_APP_NOTIFICATION_ENGINE_API;
      socket.current =
        socket.current ||
        io(url || '', {
          transports: ['websocket'],
        });
      socket.current.on('connect', () => {
        console.info('Socket connected');
        socket?.current?.emit('joinRoom', {
          roomId: `ZEECASH:${user?.id}`,
        });
      });
      socket.current.on('disconnect', () => {
        console.info('socket has been disconnected');
      });

      socket.current.on(`notification`, (notification: INotification) => {
        // Handle notification with context if needed
        if (notification.title === 'Receive Request') {
          // App is loaded, add to queue for processing (de-duplication handled in context)
          addToReceiveRequestQueue(notification);
        }
        setHasNewNotification(true);
        handleNewNotification(notification);
      });
    }
    return () => {
      socket?.current?.off('notification');
    };
  }, [user, isAppLoaded]);

  return {
    socket: socket.current,
  };
};

export default useNotificationSocket;
